var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMtsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52.81 33.42",
    style: {
      enableBackground: "new 0 0 52.81 33.42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EC1C24;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 52.81,
    height: 33.42
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "18.66,11.17 18.17,11.17 18.09,11.65 16.95,18.37 15.72,11.64 15.64,11.17 15.16,11.17 13.04,11.17  12.35,11.17 12.47,11.85 14.29,21.78 14.37,22.25 14.85,22.25 16.29,22.25 16.97,22.25 18.81,22.25 19.3,22.25 19.38,21.77  21.06,11.84 21.18,11.17 20.5,11.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "9.79,11.17 9.22,11.17 9.22,11.75 9.22,21.67 9.22,22.25 9.79,22.25 11.78,22.25 12.35,22.25  12.35,21.67 12.35,11.75 12.35,11.17 11.78,11.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "21.75,11.17 21.18,11.17 21.18,11.75 21.18,21.67 21.18,22.25 21.75,22.25 23.87,22.25 24.45,22.25  24.45,21.67 24.45,11.75 24.45,11.17 23.87,11.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "34.68,13.59 34.68,11.75 34.68,11.17 34.1,11.17 25.89,11.17 25.32,11.17 25.32,11.75 25.32,13.59  25.32,14.16 25.89,14.16 28.36,14.16 28.36,21.67 28.36,22.25 28.94,22.25 31.06,22.25 31.63,22.25 31.63,21.67 31.63,14.16  34.1,14.16 34.68,14.16  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.24,11.16h-10.6c-2.17,0-3.89,0.51-5.09,1.53c-1.16,0.98-1.78,2.37-1.78,4.02c0,1.66,0.62,3.05,1.78,4.02 c1.21,1.01,2.92,1.52,5.09,1.52h10.6h0.57v-0.57v-1.84v-0.57h-0.57h-10.6c-2.26,0-3.46-0.88-3.46-2.55c0-0.74,0.24-1.34,0.72-1.77 c0.59-0.53,1.51-0.79,2.74-0.79h10.6h0.57v-0.57v-1.84v-0.57H52.24z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtsLogo);
export default __webpack_public_path__ + "static/media/mts_logo.6a91f5bfa538530aec232bb6eb76651e.svg";
export { ForwardRef as ReactComponent };